import React, { useEffect, useState } from "react";

import "./App.css";
import "./resources/css/Sidebar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from "./components/Login";
import LoginCargo from "./components/LoginCargo";
import Home from "./components/Home/Home";

import { FinancialYearList, FinancialYearEdit } from "./components/FinancialYear";
import { BranchList, BranchEdit } from "./components/Branch";
import { ItemList, ItemEdit } from "./components/Item";
import { SupllierList, SupllierEdit, SupplierView } from "./components/Supplier";
import { ClientList, ClientEdit, ClientView } from "./components/Client";
import { TrasporterView, TrasporterEdit, TrasporterList } from "./components/Trasporter";
import { DriverEdit, DriverList } from "./components/Driver";
import { VehicleEdit, VehicleList } from "./components/Vehicle";
import { CountryEdit, CountryList } from "./components/Country";
import { StateEdit, StateList } from "./components/State";
import { CityEdit, CityList } from "./components/City";
import { ChallanEdit, ChallanView, ChallanList, ChallanDeliveryList } from "./components/Challan";
import { AdvanceChallanEdit, AdvanceChallanList } from "./components/AdvanceChallan";
import { AdvanceDieselChallanEdit, AdvanceDieselChallanList } from "./components/AdvanceDiesels";
import { ClientInvoiceEdit, ClientInvoiceList } from "./components/ClientInvoice";
import { ContactEdit, ContactList, ContactView } from "./components/Contact";
import { InvoicePaymentEdit, InvoicePaymentView, InvoicePaymentList } from "./components/InvoicePayment";
import { DriverPaymentEdit, DriverPaymentList, DriverPaymentView } from "./components/driverPayment";


// ------------------------------Trip Module Imports ---------------------------------------
import { TripChallanEdit, TripChallanView, TripChallanList, TripChallanDeliveryList } from "./components/TripChallan";
import { TripAdvanceChallanEdit, TripAdvanceChallanList } from "./components/TripAdvanceChallan";
import { TripAdvanceDieselChallanEdit, TripAdvanceDieselChallanList } from "./components/TripAdvanceDiesels";

//------------------------------------- Tyre Modules Phase-2 --------------------------------
import LoginGNRoadLinesGST from "./components/LoginGNRoadLinesGST";

// -----------------------------End Here -----------------------------------------------------
import { ViewTaskReports, TaskReports } from "./components/Report";
import { BackupList } from "./components/Backup";
import { UserProfileEdit } from "./components/User Profile";
import { UserEdit, UserList, UserView } from "./components/userManagement";
import { PurchaseOrderEdit, PurchaseOrderList, PurchaseOrderView } from "./components/purchaseOrder";
import { CategoryEdit, CategoryList } from "./components/category";
import { SubCategoryEdit, SubCategoryList } from "./components/subCategory";
import { Inventory } from "./components/inventory";
import * as constants from "./constants/CONSTANT";
import PubSub from "pubsub-js";
import { Toast, ToastContainer } from "react-bootstrap";
// Import Font Awesome CSS
import 'font-awesome/css/font-awesome.min.css';



/*********************
 * CP Code
 *******************/

import { PATHS } from "./constants/WebRouting";
import Auth from "./components/Auth/Auth";
import NoAccess from "./components/common/NoAccess";
import { getUserDetails } from "../src/utils/helper";
import { ProductEdit, ProductList, ProductView } from "./components/product";
import { ServiceOrderEdit, ServiceOrderList, ServiceOrderView } from "./components/services";
// import MainNotify from "./components/layout/MainNotify";

// import instituteApi from "../../../api/instituteApi";

/*********************
 * CP Code
 *******************/

function App() {
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState("Confirmation");
  const [message, setMessage] = useState("");

  const [variant, setVariant] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const [loginUser, setLoginUserList] = useState({});
  const mySubscriber = (msg, data) => {
    switch (msg) {
      case "RECORD_SAVED_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("success");
        break;
      case "RECORD_ERROR_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("danger");
        break;
      default:
        break;
    }
  };



  useEffect(() => {
    PubSub.subscribe("RECORD_SAVED_TOAST", mySubscriber);
    PubSub.subscribe("RECORD_ERROR_TOAST", mySubscriber);

    try {
      if (localStorage.getItem("token")) {
        let user = getUserDetails();
        setUserInfo(user);

        var perm = user.permissions
          .map(function (obj) {
            return obj.name;
          })
          .join(";");
        setPermissions(perm);
      }
    } catch (error) {
      console.log(error);
    }

    // const fetchLoginUserList = async () => {
    //   const result = await instituteApi.getLoginUserData();
    //   console.log("Login User Data =>",result)
    //   setLoginUserList(result);
    // }

    // fetchLoginUserList();

  }, []);

  console.log("constants Permission =>", constants)

  return (
    <React.Fragment key={Math.random()} >
      <ToastContainer className="p-3" position="top-center">
        <Toast
          show={modalShow}
          onClose={() => setModalShow(false)}
          delay={3000}
          bg={variant}
          className="text-white"
          autohide
        >
          {variant === "success" ? (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#198754", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          ) : (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#DC3545", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          )}

          <Toast.Body>
            {message instanceof Array ? (
              message.map((item) => {
                return <span>{item.msg}</span>;
              })
            ) : (
              <span>{message}</span>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Router >
        <Routes>
          <Route path="/" exact element={<Login />} />

          {/* GN Cargo Login */}
          <Route path="/logincargo" exact element={<LoginCargo />} />

          {/* GN RoadLines Login */}
          <Route path="/logingnroadlines" exact element={<LoginGNRoadLinesGST />} />

          {/********* Home *******/}
          {/* element={<MainNotify/>} */}
          <Route >
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/dashboard"} element={<Home />} />
            </Route>

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/home"} element={<Home />} />
            </Route>


            {/* User Mangement */}
            {/******** Show All User Mangement *******/}

            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/users"} element={<UserList />} />
            </Route>

            {/******** Create a User Mangement *******/}

            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/users/e"} element={<UserEdit />} />
            </Route>

            {/******** Show a Users By Id *******/}
            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/users/:id"} element={<UserView />} />
            </Route>

            {/******** Edit Users By Id *******/}
            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route
                path={"/users/:id/e"}
                element={
                  <>
                    {/* <Header/> */}
                    <UserEdit />
                  </>
                }
              />
            </Route>
            {/******** New Financial Year  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/financialyears/e"} element={<FinancialYearEdit />} />
            </Route>

            {/******** Edit Financial Year By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/financialyears/:id/e"} element={<FinancialYearEdit />} />
            </Route>


            {/******** Financial Year List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/financialyears"} element={<FinancialYearList />} />
            </Route>

            {/* Branch */}

            {/******** New Branch  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/branches/e"} element={<BranchEdit />} />
            </Route>

            {/******** Edit Branch By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/branches/:id/e"} element={<BranchEdit />} />
            </Route>


            {/******** Branch  List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/branches"} element={<BranchList />} />
            </Route>


            {/* Item */}
            {/******** New Item  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/items/e"} element={<ItemEdit />} />
            </Route>

            {/******** Edit Item By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/items/:id/e"} element={<ItemEdit />} />
            </Route>


            {/******** Item  List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/items"} element={<ItemList />} />
            </Route>


            {/* Suppliers */}
            {/******** New Suppliers  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/suppliers/e"} element={<SupllierEdit />} />
            </Route>

            {/******** Edit Suppliers By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/suppliers/:id/e"} element={<SupllierEdit />} />
            </Route>


            {/******** Suppliers List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/suppliers"} element={<SupllierList />} />
            </Route>

            {/******** Suppliers By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/suppliers/:id"} element={<SupplierView />} />
            </Route>

            {/* Client */}
            {/******** New Client  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clients/e"} element={<ClientEdit />} />
            </Route>

            {/******** Edit Client By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clients/:id/e"} element={<ClientEdit />} />
            </Route>


            {/******** Client List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clients"} element={<ClientList />} />
            </Route>

            {/******** Client By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clients/:id"} element={<ClientView />} />
            </Route>


            {/* Trasporter */}
            {/******** New Trasporter  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/transporters/e"} element={<TrasporterEdit />} />
            </Route>

            {/******** Edit Trasporter By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/transporters/:id/e"} element={<TrasporterEdit />} />
            </Route>


            {/******** Trasporter List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/transporters"} element={<TrasporterList />} />
            </Route>

            {/******** Trasporter By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/transporters/:id"} element={<TrasporterView />} />
            </Route>

            {/* Driver */}
            {/******** New Driver  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/drivers/e"} element={<DriverEdit />} />
            </Route>

            {/******** Edit Driver By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/drivers/:id/e"} element={<DriverEdit />} />
            </Route>


            {/******** Driver List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/drivers"} element={<DriverList />} />
            </Route>

            {/* Vehicle */}

            {/******** New Vehicle  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/vehicles/e"} element={<VehicleEdit />} />
            </Route>

            {/******** Edit Vehicle By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/vehicles/:id/e"} element={<VehicleEdit />} />
            </Route>


            {/******** Vehicle List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/vehicles"} element={<VehicleList />} />
            </Route>

            {/* County */}
            {/******** New County  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/countries/e"} element={<CountryEdit />} />
            </Route>

            {/******** Edit County By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/countries/:id/e"} element={<CountryEdit />} />
            </Route>


            {/******** County List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/countries"} element={<CountryList />} />
            </Route>


            {/* State */}
            {/******** New State  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/states/e"} element={<StateEdit />} />
            </Route>

            {/******** Edit State By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/states/:id/e"} element={<StateEdit />} />
            </Route>


            {/******** State List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/states"} element={<StateList />} />
            </Route>

            {/* City */}
            {/******** New City  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/cites/e"} element={<CityEdit />} />
            </Route>

            {/******** Edit State By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/cites/:id/e"} element={<CityEdit />} />
            </Route>


            {/******** State List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/cites"} element={<CityList />} />
            </Route>



            {/* Challan */}
            {/******** New Challan  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/challans/e"} element={<ChallanEdit />} />
            </Route>

            {/******** Edit Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/challans/:id/e"} element={<ChallanEdit />} />
            </Route>


            {/******** Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/challans"} element={<ChallanList />} />
            </Route>

            {/******** Challan By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/challans/:id"} element={<ChallanView />} />
            </Route>


            {/* Advance Challan */}

            {/******** New Advance Challan *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancechallans/e"} element={<AdvanceChallanEdit />} />
            </Route>

            {/******** Edit Advance Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancechallans/:id/e"} element={<AdvanceChallanEdit />} />
            </Route>


            {/******** Advance Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancediesels"} element={<AdvanceDieselChallanList />} />
            </Route>

            {/* Advance Diesel Challan */}

            {/******** New Advance Diesel Challan *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancediesels/e"} element={<AdvanceDieselChallanEdit />} />
            </Route>

            {/******** Edit Advance Diesel Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancediesels/:id/e"} element={<AdvanceDieselChallanEdit />} />
            </Route>


            {/******** Advance Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/advancechallans"} element={<AdvanceChallanList />} />
            </Route>


            {/* Challan Delivery */}

            {/******** Advance Challan Delivery List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/challandelivery"} element={<ChallanDeliveryList />} />
            </Route>

            {/* Contact */}

            {/******** Show All Contact *******/}

            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/contacts"} element={<ContactList />} />
            </Route>
            {/******** Create a Contact *******/}

            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/contacts/e"} element={<ContactEdit />} />
            </Route>

            {/******** Show a Contact By Id *******/}
            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/contacts/:id"} element={<ContactView />} />
            </Route>

            {/******** Edit Contact By Id *******/}
            <Route
              element={
                <Auth
                  allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]}
                />
              }
            >
              <Route path={"/contacts/:id/e"} element={<ContactEdit />} />
            </Route>


            {/******** Show All Report *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/taskreports"} element={<TaskReports />} />
            </Route>


            {/******** Report By Name *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/taskreports/:reportname"} element={<ViewTaskReports />} />
            </Route>



            {/* Client Invoices */}

            {/******** New Client Invoices *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoices/e"} element={<ClientInvoiceEdit />} />
            </Route>

            {/******** Edit Client Invoices By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoices/:id/e"} element={<ClientInvoiceEdit />} />
            </Route>


            {/******** Client Invoices List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoices"} element={<ClientInvoiceList />} />
            </Route>


            {/* Client Invoice Payment */}

            {/******** New  Client Invoice Payment *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoicepayments/e"} element={<InvoicePaymentEdit />} />
            </Route>

            {/******** Edit  Client Invoice Payment By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoicepayments/:id/e"} element={<InvoicePaymentEdit />} />
            </Route>


            {/******** Client  Client Invoice Payment *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoicepayments"} element={<InvoicePaymentList />} />
            </Route>

            {/******** Client Invoices By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/clientinvoicepayments/:id"} element={<InvoicePaymentView />} />
            </Route>

            {/* Driver Payment */}

            {/******** New  Driver Payment *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/driverpayments/e"} element={<DriverPaymentEdit />} />
            </Route>

            {/******** Edit Driver Payment By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/driverpayments/:id/e"} element={<DriverPaymentEdit />} />
            </Route>


            {/******** Driver Payment List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/driverpayments"} element={<DriverPaymentList />} />
            </Route>

            {/******** Client Driver Payment By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/driverpayments/:id"} element={<DriverPaymentView />} />
            </Route>


            {/******** User Profile Edit *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/myprofile"} element={<UserProfileEdit />} />
            </Route>

            {/******** Backup List *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/backup"} element={<BackupList />} />
            </Route>

            {/***************** Trip Modules Calles Starts Here *******************/}

            {/* Trip Challan */}

            {/******** New Trip Challan  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripchallans/e"} element={<TripChallanEdit />} />
            </Route>

            {/******** Edit Trip Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripchallans/:id/e"} element={<TripChallanEdit />} />
            </Route>


            {/******** Trip Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripchallans"} element={<TripChallanList />} />
            </Route>

            {/******** Trip Challan By Id *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripchallans/:id"} element={<TripChallanView />} />
            </Route>


            {/* Trip Advance Challan */}

            {/******** New Trip Advance Challan *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancechallans/e"} element={<TripAdvanceChallanEdit />} />
            </Route>

            {/******** Edit Trip Advance Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancechallans/:id/e"} element={<TripAdvanceChallanEdit />} />
            </Route>


            {/******** Trip Advance Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancediesels"} element={<TripAdvanceDieselChallanList />} />
            </Route>

            {/* Trip Advance Diesel Challan */}

            {/******** New Trip Advance Diesel Challan *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancediesels/e"} element={<TripAdvanceDieselChallanEdit />} />
            </Route>

            {/******** Edit Trip Advance Diesel Challan By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancediesels/:id/e"} element={<TripAdvanceDieselChallanEdit />} />
            </Route>


            {/******** Trip Advance Challan List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripadvancechallans"} element={<TripAdvanceChallanList />} />
            </Route>


            {/* Trip Challan Delivery */}

            {/******** Trip Advance Challan Delivery List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/tripchallandelivery"} element={<TripChallanDeliveryList />} />
            </Route>

            {/* Phase-2 Tyre Modules Starts Here*/}

            {/* Tyre products */}

            {/******** New products Master  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/products/e"} element={<ProductEdit />} />
            </Route>

            {/******** Edit Tyre products By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/products/:id/e"} element={<ProductEdit />} />
            </Route>

            {/******** Edit Tyre products By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/products/:id"} element={<ProductView />} />
            </Route>


            {/******** Tyre products  List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/products"} element={<ProductList />} />
            </Route>

            {/* Tyre Purchase Orders */}

            {/******** New Purchase Orders  *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/purchase-orders/e"} element={<PurchaseOrderEdit />} />
            </Route>

            {/******** Edit Tyre Purchase Orders By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/purchase-orders/:id/e"} element={<PurchaseOrderEdit />} />
            </Route>

            {/******** View Tyre Purchase Orders By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/purchase-orders/:id"} element={<PurchaseOrderView />} />
            </Route>


            {/******** Tyre Purchase Orders List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/purchase-orders"} element={<PurchaseOrderList />} />
            </Route>

            {/* Tyre Categories */}

            {/******** New Categories *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/categories/e"} element={<CategoryEdit />} />
            </Route>

            {/******** Edit Tyre Purchase Orders By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/categories/:id/e"} element={<CategoryEdit />} />
            </Route>

            {/******** Tyre Purchase Orders List *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/categories"} element={<CategoryList />} />
            </Route>

            {/******** Inventory *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/inventory"} element={<Inventory />} />
            </Route>

            {/* Tyre service-orders */}

            {/******** New service-orders *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/service-orders/e"} element={<ServiceOrderEdit />} />
            </Route>

            {/******** Edit Tyre service-orders By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/service-orders/:id/e"} element={<ServiceOrderEdit />} />
            </Route>

             {/******** Edit Tyre service-orders By Id *******/}
            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/service-orders/:id"} element={<ServiceOrderView />} />
            </Route>

            {/******** Tyre service-orders *******/}

            <Route element={<Auth allowedRoles={[constants.MODIFY_ALL, constants.CREATE_ALL]} />}>
              <Route path={"/service-orders"} element={<ServiceOrderList />} />
            </Route>


          </Route>


          {/* End Here */}

        </Routes>
      </Router>
    </React.Fragment>
  );
}

export default App;
